import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-bookable-row-entry',
  templateUrl: './bookable-row-entry.component.html',
  styleUrls: ['./bookable-row-entry.component.css']
})
export class BookableRowEntryComponent implements OnInit {

  @Input()
  calendarId: string;

  @Input()
  refUrl: string;

  @Input()
  learnMoreUrl: string;

  @Input()
  tourIcon: string = "hiking";

  @Input()
  shoutout: string;

  @Input()
  reviewRating: number;

  @Input()
  skillRating: string;

  @Input()
  price: number;

  @Input()
  strikedPrice: number;

  @Input()
  title: string;

  @Input()
  description: string;

  @Input()
  durationSnippet: string;

  @Input()
  imagePath: string;

  constructor() { }

  ngOnInit(): void {
  }
}
